// packages
import classnames from "classnames";
import React, { InputHTMLAttributes, useEffect, useRef, useState } from "react";

// styles
import styles from "./styles.module.scss";

interface Props extends InputHTMLAttributes<HTMLInputElement> {
  error?: string;
  label?: string;
  data?: { id: number; name: string }[];
  shownValue?: { id: number; name: string };
  // eslint-disable-next-line no-unused-vars
  handleChange: (value: { id: number; name: string }) => void;
}

const Dropdown: React.FC<Props> = ({
  label,
  data,
  shownValue,
  handleChange,
  ...props
}: Props) => {
  const inputRef = useRef<HTMLInputElement | null>(null);
  const ref = useRef<HTMLDivElement | null>(null);

  // const [focused, setFocused] = useState(false);
  const [showAndHideDropDown, setShowAndHideDropDown] = useState(false);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (!ref?.current?.contains(event?.target)) {
        setShowAndHideDropDown(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
  }, [ref]);

  const handleDropDownIconClick = () => {
    setShowAndHideDropDown(!showAndHideDropDown);
  };

  return (
    <div
      onClick={handleDropDownIconClick}
      ref={ref}
      className={classnames(styles.container)}>
      <div className={styles["header"]}>
        <p>{label}</p>
      </div>
      <input
        ref={inputRef}
        onFocus={(e) => {
          props?.onFocus && props.onFocus(e);
        }}
        onBlur={(e) => {
          props?.onBlur && props?.onBlur(e);
          setShowAndHideDropDown(false);
        }}
        disabled={true}
        value={shownValue?.name || ""}
        {...props}
      />
      <img
        alt="img"
        src="/assets/images/svg/downArrow.svg"
        className={styles["dropdown_icon"]}
      />
      {data && (
        <div
          className={
            showAndHideDropDown ? styles["dropdown"] : styles["dropdown-hide"]
          }>
          {data?.map((content, index) => (
            <li
              key={index}
              onClick={() => {
                handleChange(content);
                handleDropDownIconClick();
              }}>
              {content?.name}
            </li>
          ))}
        </div>
      )}
    </div>
  );
};

export default React.memo(Dropdown);
